import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { DamsAppAsset } from "../../assets/registry";
import { BadgeLabel } from "../Label/BadgeLabel";
import { green, grey } from "@mui/material/colors";
import React, { useState } from "react";


function TableHeaderLabel({
  title,
  subTitle,
  tableTitleBadge,
  headerDropDownMenu,
  rowSelected=false
  
}: Readonly<{
  title?: string;
  subTitle?: string;
  tableTitleBadge?: string;
  headerDropDownMenu?: React.ElementType<{ closeDialog: () => void }>;
  rowSelected:boolean
}>) {
  const [menuDialog, setmMenuDialog] = useState(false);
  const closeDialog = () => {
    setmMenuDialog(false);
  };
  const dialogRef = React.useRef<HTMLDivElement>(null);
  const handleClickOutside = (event: MouseEvent) => {
    if (
      dialogRef.current &&
      !dialogRef.current.contains(event.target as Node)
    ) {
      closeDialog();
    }
  };
  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Stack width={"100%"} height={75} justifyContent={"center"} p={"0px 16px"}>
      {/* header line  */}
      <Stack
        display={"flex"}
        justifyContent={"space-between"}
        direction={"row"}
        alignItems={'center'}
      >
        <Box display={"flex"} gap={1}>
          <Typography
            fontFamily={"Inter"}
            fontWeight={600}
            color={"#020202"}
            fontSize={18}
          >
            {title ?? "Table Title"}
          </Typography>

          {tableTitleBadge && (
            <BadgeLabel
              title={tableTitleBadge }
              colorType={"green"}
              tip="Selected records"
              isLarge={false}
            />
          )}
        </Box>

        {/* button Label  */}
        {
          headerDropDownMenu && rowSelected &&
          <Box sx={{mt:0.8}}>
          <IconButton onClick={() => setmMenuDialog(true)} sx={{ p: 1,backgroundColor:rowSelected? green[50]:'transparent' }}>
            <Avatar
              src={DamsAppAsset.icons.more}
              sx={styles.moreIcon}
              variant="square"
            />
          </IconButton>
          {menuDialog && headerDropDownMenu && (
            <Box
              sx={styles.headerDropDownMenuContainer}
              ref={dialogRef}
            >
              {React.createElement(headerDropDownMenu, { closeDialog })}
            </Box>
          )}
        </Box>
        }
      </Stack>

{
  subTitle &&
  <Typography
  fontFamily={"Inter"}
  fontWeight={400}
  color={"#455042"}
  fontSize={14}
  mb={2}
> {subTitle}
</Typography>
}

    </Stack>
  );
}

const styles = {
  moreIcon: {
    width: "20px",
    height: "20px",
  },
  headerDropDownMenuContainer: {
    backgroundColor: grey[50],
    border: `1px solid ${grey[400]}`,
    position: "absolute",
    width: 300,
    zIndex: 1000,
    marginLeft: -36,
    display: "flex",
    flexDirection: "column",
    alignItems: "right",
    padding: 1,
    borderRadius: 2,
  },
  headerDropDownMenu: {
    backgroundColor: "red",
    padding: 2,
    borderRadius: 2,
  },
};

export { TableHeaderLabel };
